import React from "react";
import {
  makeStyles,
} from "@material-ui/core";
import GeneralSebiActivities from "Admin/Sebi/GeneralSebiActivities";

const useStyles = makeStyles((theme) => ({
  accbWrapper: {
    '& *': {
      fontFamily: `${theme.typography.fontFamily} !important`,
    },
  },
  // minWidth rather than width, so a tab with a count badge grows instead of
  // squeezing the badge.
  accbSelected: {
    minWidth: "9rem",
    textAlign: "center",
    padding: "0.8rem 2rem",
    cursor: "pointer",
    fontSize: "0.9rem",
    fontWeight: 600,
    color: theme.palette.common.white,
    fontFamily: theme.typography.fontFamily,
    backgroundColor: theme.palette.primary.main,
  },
  accbUnselected: {
    minWidth: "9rem",
    textAlign: "center",
    padding: "0.8rem 2rem",
    cursor: "pointer",
    fontSize: "0.9rem",
    fontWeight: 700,
    color: theme.palette.primary.main,
    fontFamily: theme.typography.fontFamily,
    backgroundColor: 'white',
    border: `1px solid ${theme.palette.border}`,
  },
  accbTabsContainer: {
    gap: "1rem",
  },
}));

const GeneralActivitiesACCB = ({
  activities,
  setActivities,
  activityTitle,
  isGetActivityByTabAndId,
  disputeId,
}) => {
  const classes = useStyles();
  const activityCategories = [
    { id: "general", label: "General" },
    { id: "files", label: "Files" },
    { id: "bookings", label: "Hearings" },
  ];

  const activityTabClasses = {
    selected: classes.accbSelected,
    unselected: classes.accbUnselected,
  };


  return (
    <div className={classes.accbWrapper}>
      <GeneralSebiActivities
        activities={activities}
        setActivities={setActivities}
        activityTitle={activityTitle || "Account Activity"}
        activityCategories={activityCategories}
        tabsClasses={activityTabClasses}
        tabsContainerClass={classes.accbTabsContainer}
        isDefaultFont={true}
        isGetActivityByTabAndId={isGetActivityByTabAndId}
        disputeId={disputeId}
      />
    </div>
  );
};

export default GeneralActivitiesACCB;
